import { Trans } from 'react-i18next';
import { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';

import { Link } from 'react-router-dom';
import routes from '@/routes';
import { SUPPORT_EMAIL, TRIAL_DAYS } from '@/config';
import { formatPrice } from '@/utils';
import { useTrialDiscount } from '@/hooks';

function StaticTermsDisclaimer({
	isTrialPlan,
	trialPlan,
	monthlyPlan,
	buttonLabel
}) {
	return (
		<Typography
			variant="body1"
			sx={{
				alignItems: 'flex-start'
			}}
		>
			<DescriptionText
				isTrialPlan={isTrialPlan}
				trialPlan={trialPlan}
				monthlyPlan={monthlyPlan}
				buttonLabel={buttonLabel}
			/>
		</Typography>
	);
}

const linkStyles = {
	color: 'primary.main',
	transition: 'color 0.25s ease',
	fontWeight: 600,

	'&:hover': { color: 'primary.dark' }
};

function LinkButton({ to, ...rest }) {
	return (
		<Box component={Link} target="_blank" sx={linkStyles} to={to} {...rest} />
	);
}

const DescriptionText = forwardRef(
	({ isTrialPlan, trialPlan, monthlyPlan, buttonLabel, ...props }, ref) => {
		const trialDiscount = useTrialDiscount();

		const supportLink = (
			<Box component="a" href={`mailto:${SUPPORT_EMAIL}`} sx={linkStyles}>
				{SUPPORT_EMAIL}
			</Box>
		);

		const { baseAmount, currency } = monthlyPlan || {};

		const trialPrice = formatPrice({
			amount: trialDiscount ? 0 : trialPlan?.baseAmount,
			currency: trialPlan?.currency
		});

		const monthlyPrice = formatPrice({ amount: baseAmount, currency });

		return (
			<Trans
				i18nKey={isTrialPlan ? 'checkout.terms' : 'checkout.termsMonthly'}
				components={{
					anchor1: <LinkButton to={routes.termsAndConditions} />,
					anchor2: <LinkButton to={routes.privacyPolicy} />,
					supportLink
				}}
				values={{
					monthlyPrice,
					trialPrice,
					trialDays: TRIAL_DAYS,
					buttonLabel
				}}
				ref={ref}
				{...props}
			/>
		);
	}
);

export default StaticTermsDisclaimer;
